import { styled } from '@mui/material/styles';

export const IconContainer = styled('div')(({ theme }) => ({
  display: "flex", 
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,

  transition: '200ms ease all',
}));